<template>
  <div>
    <v-row>
      <v-col cols="12" sm="12" md="2"> </v-col>
      <v-col cols="12" sm="12" md="8">
        <v-card class="mx-auto my-5 mb-16" max-width="1000">
          <v-app-bar flat>
            <span class="headline">{{ formCompData.title }}</span>
          </v-app-bar>
          <v-card-text>
            <v-container>
              <formComponent
                ref="formComponent"
                :form="formComp"
                v-model="formComp.eventForm"
              />
            </v-container>
          </v-card-text>

          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="grey" outlined @click="closeform">{{
              $t("general.back")
            }}</v-btn>
            <v-btn color="primary" @click="saveForm(false)" data-cy="saveEvent">
              <div
                v-if="
                  $route.params.mode === 'new' || $route.params.mode === 'copy'
                "
              >
                {{ $t("general.save") }}
              </div>
              <div v-if="$route.params.mode === 'edit'">
                {{ $t("general.saveChanges") }}
              </div>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="2"> </v-col>
    </v-row>
  </div>
</template>

<script>
import i18n from "../../i18n";
function getDefaultData() {
  return {
    dangerousGoodStorageLocation: "",
    identifier: "",
    name: "",
    pictograms: [],
    h: [],
    p: [],
    storageClassification: "",
    waterHazardClass: "",
    containerSize: "",
    yearlyUsage: "",
    usageLocation: "",
    manufacturer: "",
    responsiblePerson: "",
    fss7Relevant: false,
    safetyDataSheet: null,
    safetyDataSheetDate: null,
    additionalFiles: [],
    operatingInstruction: null,
    betriebsanweisung: null,
    pendingOperatingInstruction: null,
  };
}
import formComponent from "../../components/_utils/formComponent/formComponent.vue";
import { getUniqueId } from "../../components/api/api";
import { WATER_HAZARD_CLASS_ITEMS } from "../../data/waterHazardClasses";
const classifications = require("../../assets/dangerousGoodsStorageClassification.json");
const allStorageClassificationsMap = Object.keys(classifications).map(
  (key) => ({
    name: key,
    value: key,
  })
);
export default {
  components: { formComponent },
  props: ["data"],
  data: () => ({
    formCompData: {
      title: "dangerousGoods.dangerousGoodsList.new",
      item: null,
    },
    formComp: {
      eventForm: getDefaultData(),
      form: [
        [
          {
            cols: 12,
            id: getUniqueId(),
            class: "pb-0",
            componentName: "storageLocationName",
          },
        ],
        [
          {
            cols: 12,
            id: getUniqueId(),
            componentName: "dangerousGoodIdentifier",
          },
        ],
        [
          {
            cols: 12,
            id: getUniqueId(),
            componentName: "vTextField",
            config: {
              vModel: "name",
              label: i18n.t("dangerousGoods.dangerousGoodsList.form.name"),
              dataCy: "name",
              rules: [(v) => !!v || i18n.t("general.fieldNeedsToBeFilled")],
            },
          },
        ],
        [
          {
            cols: 12,
            id: getUniqueId(),
            componentName: "dangerousGoodsListPictograms",
          },
        ],
        [
          {
            cols: 12,
            id: getUniqueId(),
            componentName: "selectHSentences",
          },
        ],
        [
          {
            cols: 12,
            id: getUniqueId(),
            componentName: "selectPSentences",
          },
        ],
        [
          {
            cols: 12,
            id: getUniqueId(),
            componentName: "vSelect",
            config: {
              vModel: "storageClassification",
              items: allStorageClassificationsMap,
              label: i18n.t(
                "dangerousGoods.dangerousGoodsList.form.storageClassification"
              ),
              dataCy: "storageClassification",
            },
          },
        ],
        [
          {
            cols: 12,
            id: getUniqueId(),
            componentName: "vSelect",
            config: {
              vModel: "waterHazardClass",
              items: WATER_HAZARD_CLASS_ITEMS,
              label: i18n.t(
                "dangerousGoods.dangerousGoodsList.form.waterHazardClass"
              ),
              dataCy: "waterHazardClass",
            },
          },
        ],
        [
          {
            cols: 12,
            id: getUniqueId(),
            componentName: "vTextField",
            config: {
              vModel: "containerSize",
              label: i18n.t(
                "dangerousGoods.dangerousGoodsList.form.containerSize"
              ),
              dataCy: "containerSize",
            },
          },
        ],
        [
          {
            cols: 12,
            id: getUniqueId(),
            componentName: "vTextField",
            config: {
              vModel: "yearlyUsage",
              label: i18n.t(
                "dangerousGoods.dangerousGoodsList.form.yearlyUsage"
              ),
              dataCy: "yearlyUsage",
            },
          },
        ],
        [
          {
            cols: 12,
            id: getUniqueId(),
            componentName: "vTextField",
            config: {
              vModel: "usageLocation",
              label: i18n.t(
                "dangerousGoods.dangerousGoodsList.form.usageLocation"
              ),
              dataCy: "usageLocation",
            },
          },
        ],
        [
          {
            cols: 12,
            id: getUniqueId(),
            componentName: "vTextField",
            config: {
              vModel: "manufacturer",
              label: i18n.t(
                "dangerousGoods.dangerousGoodsList.form.manufacturer"
              ),
              dataCy: "manufacturer",
            },
          },
        ],
        [
          {
            cols: 12,
            id: getUniqueId(),
            componentName: "responsiblePersonSelect",
          },
        ],
        [
          {
            cols: 12,
            id: getUniqueId(),
            componentName: "fss7Relevance",
          },
        ],
        [
          {
            cols: 12,
            id: getUniqueId(),
            componentName: "safetyDataSheetUpload",
          },
        ],
        [
          {
            cols: 12,
            id: getUniqueId(),
            class: "py-0",
            componentName: "safetyDataSheetDate",
          },
        ],
        [
          {
            cols: 12,
            id: getUniqueId(),
            class: "pt-4",
            componentName: "dangerousGoodOperatingInstruction",
          },
        ],
        [
          {
            cols: 12,
            id: getUniqueId(),
            class: "pt-4",
            componentName: "additionalFilesUpload",
          },
        ],
      ],
    },
  }),
  mounted() {
    this.switchFormModes(this.$route.params.mode, this.$route.params);
  },
  methods: {
    switchFormModes(mode, params) {
      switch (mode) {
        case "edit":
          this.$store
            .dispatch("getSingleDangerousGood", params.id)
            .then((item) => {
              this.formCompData.title = this.$t(
                "dangerousGoods.dangerousGoodsList.edit"
              );
              this.formComp.eventForm = item;
            });
          break;
        case "copy": {
          this.$store
            .dispatch("getSingleDangerousGood", params.id)
            .then((item) => {
              this.formCompData.title = this.$t(
                "dangerousGoods.dangerousGoodsList.copy"
              );
              this.formComp.eventForm = item;
              //delete individual data
              delete this.formComp.eventForm._id;
              delete this.formComp.eventForm.id;
              delete this.formComp.eventForm.createdAt;
              delete this.formComp.eventForm.createdBy;
              delete this.formComp.eventForm.updatedAt;
            });
          break;
        }
        case "new":
          this.formCompData.title = this.$t(
            "dangerousGoods.dangerousGoodsList.new"
          );
          break;
      }
    },
    closeform() {
      this.resetData("new");
    },
    //a linked document can arrive populated, the API expects plain ids
    flattenDocumentReferences() {
      const toId = (reference) =>
        typeof reference === "object" && reference !== null
          ? reference._id || reference.id || null
          : reference || null;

      const form = this.formComp.eventForm;
      form.operatingInstruction = toId(form.operatingInstruction);
      form.betriebsanweisung = toId(form.betriebsanweisung);
    },
    //a category typed by hand is created the first time it is used
    async resolveInstructionCategory(name) {
      const response = await this.$store.dispatch(
        "getAllInstructionCategories"
      );
      const categories = response?.data || response || [];

      const existing = categories.find(
        (category) =>
          String(category.name ?? "")
            .trim()
            .toLowerCase() === name.toLowerCase()
      );
      if (existing) return existing._id || existing.id;

      const created = await this.$store.dispatch("createInstructionCategory", {
        name: name,
      });
      return created ? created._id || created.id : null;
    },
    //turns a picked file into a real operating instruction and links it
    async applyPendingOperatingInstruction() {
      const pending = this.formComp.eventForm.pendingOperatingInstruction;
      if (!pending) return true;

      if (!pending.categoryName) {
        this.$store.commit(
          "CREATE_SNACKBAR",
          this.$t(
            "dangerousGoods.dangerousGoodsList.form.instructionCategoryRequired"
          )
        );
        return false;
      }

      const instructionCategory = await this.resolveInstructionCategory(
        pending.categoryName
      );
      if (!instructionCategory) return false;

      const created = await this.$store.dispatch("createOperatingInstruction", {
        name: pending.name,
        filetype: pending.filetype,
        content: pending.content,
        instructionCategory: instructionCategory,
      });
      if (!created) return false;

      this.formComp.eventForm.operatingInstruction = created._id || created.id;
      this.formComp.eventForm.betriebsanweisung = null;
      this.formComp.eventForm.pendingOperatingInstruction = null;

      return true;
    },
    async saveForm(createNew) {
      // createNew : Boolean
      //check if new contact form should be opened after save
      //validate form
      if (!this.$refs.formComponent.validateAllFields()) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        return;
      }
      {
        if (!(await this.applyPendingOperatingInstruction())) return;
        this.flattenDocumentReferences();

        if (
          this.$route.params.mode === "new" ||
          this.$route.params.mode === "copy"
        ) {
          //create new item
          this.$store
            .dispatch("createDangerousGood", this.formComp.eventForm)
            .then((val) => {
              this.afterUpdateCheck(val, createNew, "new");
            });
        } else {
          //edit item
          this.$store
            .dispatch("updateDangerousGood", this.formComp.eventForm)
            .then((val) => {
              this.afterUpdateCheck(val, createNew, "edit");
            });
        }
      }
    },
    afterUpdateCheck(val, createNew, mode) {
      if (createNew) {
        //reset contact data to create new one
        this.resetData(mode);
      } else {
        //close form
        this.closeform();
      }
    },
    openDialog(val) {
      this.occupiedDialog.open = true;
      this.occupiedDialog.events = val;
    },
    resetData(mode) {
      //reset whole form data
      this.formComp.eventForm = getDefaultData();
      //reset form component form only after contact create
      if (mode === "new") {
        this.$refs.formComponent.resetForm();
      }
      //trigger reload data function in parent component
      this.reloadData();
      this.$router.back();
    },
    reloadData() {
      this.$emit("reloadData");
    },
  },
};
</script>
